import { render, staticRenderFns } from "./ChatbotIcon.vue?vue&type=template&id=1b9dfe6e&scoped=true"
import script from "./ChatbotIcon.vue?vue&type=script&lang=js"
export * from "./ChatbotIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9dfe6e",
  null
  
)

export default component.exports